// extracted by mini-css-extract-plugin
export var categoriesBar = "survey-fill-nav-module--categories-bar--EjVLV";
export var categoryPill = "survey-fill-nav-module--category-pill--fbIIS";
export var current = "survey-fill-nav-module--current--4mziq";
export var linkLogo = "survey-fill-nav-module--link-logo--e2rYc";
export var logo = "survey-fill-nav-module--logo--vtW+l";
export var pageCounter = "survey-fill-nav-module--page-counter--rytfS";
export var previous = "survey-fill-nav-module--previous--S9QGQ";
export var surveyNav = "survey-fill-nav-module--survey-nav--jo5s3";